module.exports = __webpack_public_path__ + "img/3.5541455c.jpg";